module.exports = __webpack_public_path__ + "cecf93e4d45bdcc5ea8f55b78c8e5433.svg";